import {
  User,
  Settings,
  FileText,
  Home,
  DollarSign,
  Clock,
  Coffee,
  AlertTriangle,
  UsersRound,
  MessageSquare,
} from "lucide-react";
import { createAvatar } from "../utils/adminLevelUtils";

export const getNavItems = (t) => [
  {
    icon: User,
    text: t.profile,
    page: "professionalProfile"
  },
  {
    icon: Clock,
    text: t.attendance,
    page: "attendance",
  },
  {
    icon: DollarSign,
    text: t.salaryBenefits,
    page: "salary",
  },
  {
    icon: FileText,
    text: t.employeeSelfServices,
    page: "employee-services",
  },
  {
    icon: Home,
    text: t.calendar,
    page: "calendar",
  },
  {
    icon: MessageSquare,
    text: t.messages,
    page: "messages",
  },
  {
    icon: Coffee,
    text: t.leaveManagement,
    page: "leave-management",
  },
  {
    icon: AlertTriangle,
    text: t.escalation,
    page: "escalation",
  },
  {
    icon: UsersRound,
    text: t.groups,
    page: "groups",
  },
  {
    icon: Settings,
    text: t.settings,
    page: "settings",
  },
];

// The signed-in employee, from the server-confirmed profile only (the shell
// renders once SessionGate has it). A missing value is shown as "--", never
// replaced by a stored value or a placeholder identity.
export const buildEmployeeData = (profile, t) => {
  const _phone     = profile?.employeePhone        || "";
  const _emergency = profile?.emergencyPhoneNumber || "";
  const _name      = profile?.employeeName || profile?.employeeArabicName || "";
  return {
    id:               profile?.infinityCode                 || "--",
    name:             _name || "--",
    position:         profile?.position ?? profile?.employeeType ?? "--",
    department:       profile?.department ?? profile?.employeeType ?? "--",
    email:            profile?.employeeEmail                || "--",
    phone:            _phone ? "+20" + _phone : "--",
    address:          profile?.address || profile?.location || "--",
    joinDate:         profile?.hiringDate                   || null,
    employeeId:       profile?.infinityCode                 || "--",
    manager:          profile?.firstLineManagerName         || "--",
    status:           profile?.employeeState                || "--",
    avatar:           _name ? createAvatar(_name) : "",
    birthDate:        profile?.DoB                          || null,
    nationalId:       profile?.nationalId                   || "--",
    emergencyContact: _emergency ? "+20" + _emergency : "--",
    workLocation:     profile?.location                     || "--",
    firstLevelManager: profile?.firstLineManagerInfinityCode || "--",
  };
};

export const buildSalaryData = (profile) => ({
  netSalary: parseFloat(profile?.netSalary || "0") || 0,
});
